import React, { useState } from 'react';

import { useAccountProfileContext } from '../context';

import UsersItem from './UsersItem';
import UsersItemCreate from './UsersItemCreate';

const Users: React.FC = () => {
  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const { state } = useAccountProfileContext();
  const { account } = state;
  const { user_set } = account;

  const handleSetIsCreatingUser = (): void => {
    setIsCreatingUser((prevState) => !prevState);
  };

  if (isCreatingUser) {
    return <UsersItemCreate handleSetIsCreatingUser={handleSetIsCreatingUser} />;
  }

  return (
    <div className="flex flex-col overflow-auto bg-white-0.0 mt-6">
      <button
        type="button"
        className="btn btn-secondary ml-auto font-semibold"
        data-testid="create-user"
        onClick={handleSetIsCreatingUser}
      >
        Create user
      </button>
      <ul className="mt-4" data-testid="users">
        {user_set.map((user) => (
          <li
            className="hover:bg-white-1.0 focus:outline-none focus:bg-white-1.0 block transition duration-150 ease-in-out rounded sm:px-6 px-4 py-4"
            key={user.id}
            data-testid={`user-${user.id}`}
          >
            <UsersItem user={user} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Users;
